import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 30% 50%, oklch(0.56 0.19 24) 0%, transparent 60%), radial-gradient(circle at 70% 30%, oklch(0.73 0.17 85) 0%, transparent 50%)',
        }}
      />

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 mt-12 md:mt-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>全网热播剧集 · 每日更新</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              木瓜影视
              <span className="block text-primary-500 mt-1">高清电视剧大全</span>
            </h1>

            <p className="mt-4 md:mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              海量高清电视剧全集免费在线观看，最新热播剧不缓冲无广告极速播放。国产、日韩、欧美等全类型剧集每日更新，追剧就上木瓜影视。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line mr-2"></i>热门榜单
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto px-7 py-3 border border-secondary-300 text-foreground-700 font-medium rounded-md hover:bg-secondary-100 hover:border-secondary-400 transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>开始追剧
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/10 to-accent-500/10 rounded-2xl blur-xl" />
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20composition%20showing%20a%20modern%20streaming%20interface%20concept%20with%20floating%20film%20frames%20containing%20abstract%20drama%20scenes%20in%20warm%20coral%20and%20golden%20tones%2C%20dark%20theater-like%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20and%20dramatic%20atmosphere%2C%20luxurious%20cinema%20aesthetic%2C%20high-end%20entertainment%20brand%20visual%2C%20no%20text%20or%20logos&width=700&height=500&seq=hero-main-visual-01&orientation=landscape"
                alt="木瓜影视高清电视剧在线观看主视觉"
                title="木瓜影视-电视剧大全高清在线观看"
                className="relative w-full h-auto rounded-xl object-cover"
                style={{ aspectRatio: '7/5' }}
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) parent.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}